import React, {useRef, useState, useEffect} from 'react';
import FormControl, {FormControlProps} from '@material-ui/core/FormControl';
import OutlinedInput, {OutlinedInputProps} from '@material-ui/core/OutlinedInput';
import Select, {SelectProps} from '@material-ui/core/Select';
import ReactDOM from 'react-dom';
import InputLabel, {InputLabelProps} from '@material-ui/core/InputLabel';
import {uniqueId} from 'lodash';

export interface OutlinedSelectProps extends SelectProps {
    label: InputLabelProps['children'];
    OutlinedInputProps?: Partial<OutlinedInputProps>;
    FormControlProps?: Partial<FormControlProps>;
}

export default function OutlinedSelect({
    label,
    margin,
    style,
    OutlinedInputProps: outlinedInputProps,
    FormControlProps: formControlProps,
    ...props
}: OutlinedSelectProps) {

    const [labelWidth, labelRef] = useLabelWidth();
    const {current: id} = useRef(uniqueId('outlinedSelect'));

    return <FormControl variant='outlined' style={style} margin={margin} {...formControlProps}>
        <InputLabel ref={labelRef} htmlFor={id}>{label}</InputLabel>
        <Select
            input={<OutlinedInput
                margin={margin}
                id={id}
                labelWidth={labelWidth}
                {...outlinedInputProps}
            />}
            margin={margin}
            {...props}
        />
    </FormControl>;
}

export function useLabelWidth(): [number, React.RefObject<HTMLLabelElement>] {
    const ref = useRef() as React.RefObject<HTMLLabelElement>;
    const [width, setWidth] = useState<number>(0);

    useEffect(() => {
        if (!ref.current) return;
        const node = ReactDOM.findDOMNode(ref.current);
        if (!(node instanceof HTMLElement)) return;
        const nextWidth = node.offsetWidth;
        if (width !== nextWidth) setWidth(nextWidth);
    }, [ref, width]);

    return [width, ref];
}
